import { createApi } from "@reduxjs/toolkit/query/react";

import { ISingleDaySheet, ITimeSheet } from "@/interfaces/timeTracking";
import { T_UpdateTimeSheetSchema } from "@/schemas/time-tacking.schema";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

type SheetType = "employee" | "subcontractor";

export const userTimetrackingApi = createApi({
  reducerPath: "userTimetrackingApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["employee-time-sheet", "subcontractor-time-sheet"],
  endpoints: (builder) => ({
    // get the employee / subcontractor sheet
    getSheetByType: builder.query<
      GeneralSingleResponse<ITimeSheet> | GeneralResponse<ITimeSheet[]>,
      { sheetType: SheetType; params?: string; filter?: string }
    >({
      query: ({ sheetType, params, filter }) =>
        `workspace/${getWorkspace()}/timetracking/sheet/${sheetType}/${params ? params : ""}${filter ? filter : ""}`,
      providesTags: (_result, _error, { sheetType }) => {
        return [`${sheetType}-time-sheet`];
      },
    }),

    // get the employee / subcontractor single sheet detail

    getSingleTimeSheet: builder.query<
      GeneralSingleResponse<ISingleDaySheet>,
      { sheetType: SheetType; userSheetId: string }
    >({
      query: ({ sheetType, userSheetId }) =>
        `workspace/${getWorkspace()}/timetracking/sheet/${sheetType}/sheet/${userSheetId}`,
      providesTags: (_result, _error, { sheetType }) => {
        return [`${sheetType}-time-sheet`];
      },
    }),

    mutateSingleTimeSheet: builder.mutation<
      object,
      {
        sheetType: SheetType;
        userSheetId: string;
        data: T_UpdateTimeSheetSchema;
      }
    >({
      query: ({ sheetType, userSheetId, data }) => ({
        url: `workspace/${getWorkspace()}/timetracking/sheet/${sheetType}/${userSheetId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { sheetType }) => {
        return [`${sheetType}-time-sheet`];
      },
    }),
  }),
});

export const {
  useGetSheetByTypeQuery,
  useGetSingleTimeSheetQuery,
  useMutateSingleTimeSheetMutation,
} = userTimetrackingApi;
